import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import keys from "./keys";
import { Auth0User } from "./types";
import { useApi } from "../client";

export const useUsers = ({ id }: { id: string }) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.all(),
    queryFn: async (): Promise<{ data: Auth0User[] }> => {
      const users = await api.get(`clients/${id}/users`);
      return await users.json();
    },
  });
};

export const useUsersSuspense = ({ id }: { id: string }) => {
  const api = useApi();
  return useSuspenseQuery({
    queryKey: keys.one(id),
    queryFn: async (): Promise<{ data: Auth0User[] }> => {
      const users = await api.get(`clients/${id}/users`);
      return await users.json();
    },
  });
};
